import { useEffect, useState } from "react";
import { styled, Switch, alpha, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { fetchFeaturedLinks } from "../../../action/getFeaturedLinksAdmin";

const RedSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#ef364e",
    "&:hover": {
      backgroundColor: alpha("#ef364e", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#ef364e",
  },
}));

export default function EnableSwitch({ value, api, setOpenSub }) {
  const [checked, setChecked] = useState(value.enable);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();

  useEffect(() => {
    // if (api == "goal-sub-categories") {
    setChecked(value.enable);
    // }
  }, [value]);

  // if (api == "goal-sub-categories") {
  //   "";
  // }

  const handleChange = async (e) => {
    setLoading(true);
    if (api == "goal-categories") {
      dispatch({ type: "UPDATE_GOAL_CATEGORY_ADMIN_REQUEST" });
    }
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/${api}`,
        {
          id: value.id,
          enable: e.target.checked,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data?.success) {
        toast.success(response?.data?.message);
        // setChecked(response.data?.body?.enable);
        if (api == "goal-categories") {
          setOpenSub(response.data?.body?.enable);
          dispatch({
            type: "UPDATE_GOAL_CATEGORY_ADMIN_SUCCESS",
            payload: response.data.body,
          });
        } else {
          dispatch(fetchFeaturedLinks(token, 1));
          // dispatch({
          //   type: "UPDATE_GOAL_SUB_CATEGORY_ADMIN_SUCCESS",
          //   payload: response?.data?.body,
          // });
        }
      }
    } catch (error) {
      toast.error("Something went wrong!");
      if (api == "goal-categories") {
        dispatch({
          type: "UPDATE_GOAL_CATEGORY_ADMIN_FAILURE",
          payload: error.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <RedSwitch disabled={loading} checked={checked} onChange={handleChange} />
    </>
  );
}
